import axios from "axios"

const actionGetMilkExtractions = async ({commit}, payload) => {
  const results = await axios.get(`${process.env.VUE_APP_URL_API}/v1/reports/${payload.id}/extract`, {
    params: {
      report_type: payload.report_type
    }
  });
  commit("SET_RESULTS", results.data);
}

export default {
  actionGetMilkExtractions
}